(function () {
    'use strict';

    run.superadmin.parts.clock = function() {
        // Show server time in superadmin menu
        const containerTimeServer = document.getElementById('current_time_server');
        const containerTimeLa = document.getElementById('current_time_la');
        const containerTimeBsAs = document.getElementById('current_time_bsas');

        if (typeof(containerTimeServer) != 'undefined' && containerTimeServer != null) {
            const _timerServer = setInterval(timerServer, 1000);
            const _timerLA = setInterval(timerLA, 1000);
            const _timerBsAs = setInterval(timerBsAs, 1000);
        }

        function timerServer() {
            let d = new Date();
            containerTimeServer.innerHTML = '<strong>Server</strong><br>' + d.toUTCString();
        }

        function timerLA() {
            let d2 = new Date();
            containerTimeLa.innerHTML = '<strong>Los Angeles</strong><br>' + d2.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
        }

        function timerBsAs() {
            let d3 = new Date();
            containerTimeBsAs.innerHTML = '<strong>Buenos Aires</strong><br>' + d3.toLocaleString('en-US', { timeZone: 'America/Argentina/Buenos_Aires' });
        }
    };
})();